import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';

import { MySubtitleH4 } from '../../styled/publicTag';
import { message } from 'antd';

import {  ExclamationCircleOutlined } from '@ant-design/icons';
import { getNgItem, deleteNgItem } from '../../services/api/BadProject';

import ModalContainer from './ModalContainer'

import Title from '../../components/Custom/Title';
import CustomTable from '../../components/antdCustom/CustomTable';
import CustomModal from '../../components/antdCustom/CustomModal';

import {
  IconTrash,
  IconPen
} from '../../components/Icon'


message.config({
  duration: 1.5
})

const BadProject = () => {

  const innerWidth = window.innerWidth;

  const [s_tableData, set_s_tableData] = useState([]);
  const [s_showModal, set_s_showModal] = useState(false);  // 是否開啟 dialog
  const [s_BadProjectData, set_s_BadProjectData] = useState({});     // 要編輯的模具資料
  const [s_searchValue, set_s_searchValue] = useState('');    // 要搜尋的文字

  const [pageInfo, setPageInfo] = useState({
    currentPage: 0,
    pageItemNumber: 10,
    totalItems: 0,
    pageSize: 10
  });

  // 新增不良項目資料
  const createBadProject = () => {
    set_s_showModal(true);
  }

  // 搜尋不良項目資料
  const onSearch = (value, event) => {
    const call_getNgItem = async (value) => {
      
      if(value === '') return;
      
      const res = await getNgItem({item: value});
      console.log('search res = ', res)
      
      if(res.status) {
        set_s_tableData(res.data);
        message.success(res.msg);
      } else {
        message.error(res.msg);
      }

    }
    call_getNgItem(value);
  }

  // 編輯不良項目資料
  const editBadProject = rowData => {
    set_s_showModal(true);
    set_s_BadProjectData(rowData);
  }

   // 刪除不良項目資料
   const removeBadProject = rowData => {
    Modal.confirm({
      title: '不良項目資料刪除確認',
      icon: <ExclamationCircleOutlined style={{color: 'red'}} />,
      content: '請先確認要刪除的不良項目資料無誤，再進行刪除',
      okText: '確定',
      onOk: async () => {
        const res = await deleteNgItem(rowData);
        res.status ? message.success(res.msg) : message.error(res.msg);
        //刪除後要更新資料
        call_getAllBadProject();
      },
      cancelText: '取消',
    });
  }

  // 取得所有不良項目資料
  const call_getAllBadProject = async () => {
    try {
      const res = s_searchValue === '' ? await getNgItem() : await getNgItem({item: s_searchValue});
      console.log('res = ', res)
      if(res.data) {
        console.log('全部不良品資料 = ', res.data);
        const tmpData = res.data.map((item, index) => {
          return {
            ...item,
            key: index
          }
        });
        set_s_tableData(tmpData)
      } else {
        set_s_tableData([])
      }
      
    } catch (e) {
      console.log('---------- api getNgItem error ----------');
      console.log(e)
    }
  }
  
  const tableColumns = [
    {
      title: '項目ID',
      dataIndex: 'item',
      key: 'item',
      align: 'center',
      // width: innerWidth <= 1440 ? `${200}px` : `${300}px`
    },
    {
      title: '項目名稱',
      dataIndex: 'itemNM',
      key: 'itemNM',
      align: 'center',
      // width: innerWidth <= 1440 ? `${200}px` : `${250}px`
    },
    {
      title: '註記',
      dataIndex: 'note',
      key: 'note',
      align: 'center',
      // width: innerWidth <= 1440 ? `${100}px` : `${150}px`
    },
    {
      title: '操作',
      dataIndex: 'render',
      key: 'render',
      align: 'center',
      width: innerWidth <= 1440 ? `${50}px` : `${50}px`,
      render: (text, rowData, index) => (
        <div style={{display: 'flex',justifyContent: 'center'}}>
          <div style={{display: 'flex'}}>
            <IconPen className='icon' onClick={() => editBadProject(rowData)} />
            <IconTrash className='icon' onClick={() => removeBadProject(rowData)} />
          </div>
        </div>
      )
    },
  ]

  // 取得所有不良項目資料
  useEffect(() => { 
    call_getAllBadProject();
  }, []);

  const handleChange = async value => {
    console.log(value)
    set_s_searchValue(value)
    if(value === '') {
      try {
        const res = await getNgItem();
        console.log('res = ', res)
        if(res.data) {
          console.log('全部不良品資料 = ', res.data);
          const tmpData = res.data.map((item, index) => {
            return {
              ...item,
              key: index
            }
          });
          set_s_tableData(tmpData)
        }
        
      } catch (e) {
        console.log('---------- api getNgItem error ----------');
        console.log(e)
      }
    }
  }
  
  return (
    <>
      <Title 
        title='不良項目管理'
        placeholder='請輸入欲查詢項目資料'
        onSearch={onSearch}
        handleChange={handleChange}
        handleClick={createBadProject}
      />
      <CustomTable 
        scroll={{x: 'max-content', y: window.innerHeight - 60 - 45 - 220 }}
        columns={tableColumns}
        dataSource={s_tableData.map((item, index) => {
          return {
            key: index,
            ...item
          }
        })}
        pagination={{
          defaultCurrent: 1,
          total: pageInfo.totalItems,
          // current: abcBoardConfig.page,
          showSizeChanger: true,
          pageSize: pageInfo.pageSize,
          pageSizeOptions: ["10", "20", "30"],
          onChange: (current, size) => {
            setPageInfo({
              ...pageInfo,
              pageSize: size
            })
          },
          showTotal: (total, range) => (
            <MySubtitleH4>
              共 {total} 項 ， 正在顯示第{range[0]}到{range[1]}項
            </MySubtitleH4>
          ),
        }}
      />
      {s_showModal ? (
        <CustomModal 
          width='30%' 
          title={Object.keys(s_BadProjectData).length > 0 ? "修改不良品項目資料" : "新建不良品項目資料"} 
          visible={s_showModal} 
          maskClosable={false}
          destroyOnClose
          footer={null}
          forceRender
          getContainer={false}
          onCancel={() => set_s_showModal(false)}
          afterClose={() => {
            set_s_BadProjectData({});
            call_getAllBadProject();
          }}
        >
          <ModalContainer set_s_showModal={set_s_showModal} s_BadProjectData={s_BadProjectData} set_s_BadProjectData={set_s_BadProjectData} call_getAllBadProject={call_getAllBadProject} />
        </CustomModal>
      ) : null}
      
    </>
  )
};

export default BadProject;